"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfToolCallDto = instanceOfToolCallDto;
exports.ToolCallDtoFromJSON = ToolCallDtoFromJSON;
exports.ToolCallDtoFromJSONTyped = ToolCallDtoFromJSONTyped;
exports.ToolCallDtoToJSON = ToolCallDtoToJSON;
exports.ToolCallDtoToJSONTyped = ToolCallDtoToJSONTyped;
/**
 * Check if a given object implements the ToolCallDto interface.
 */
function instanceOfToolCallDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('input' in value) || value['input'] === undefined)
        return false;
    return true;
}
function ToolCallDtoFromJSON(json) {
    return ToolCallDtoFromJSONTyped(json, false);
}
function ToolCallDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'input': json['input'],
        'result': json['result'] == null ? undefined : json['result'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'imageMimeType': json['imageMimeType'] == null ? undefined : json['imageMimeType'],
    };
}
function ToolCallDtoToJSON(json) {
    return ToolCallDtoToJSONTyped(json, false);
}
function ToolCallDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'input': value['input'],
        'result': value['result'],
        'imageUrl': value['imageUrl'],
        'imageMimeType': value['imageMimeType'],
    };
}
//# sourceMappingURL=ToolCallDto.js.map